import { FormArray } from '@angular/forms';
import { ZentraComponent } from '../../../interfaces/subProduct.interface';

/* istanbul ignore next */
export function buildComponentLineItems(
  selectedComponents: { component: ZentraComponent; quantity: number }[],
  componentsFormArray: FormArray
) {
  return selectedComponents.map((comp, index) => {
    const componentControl = componentsFormArray.at(index);
    const useCustomPrice = componentControl.get('useCustomPrice')?.value;
    const customPrice = componentControl.get('customPrice')?.value;

    return {
      name: comp.component.name,
      unit_price: comp.component.prices?.[0]?.unitPrice || '0',
      component_id: comp.component.id.toString(),
      allocated_quantity: comp.quantity.toString(),
      custom_price: useCustomPrice ? customPrice.toString() : null,
      price_point_id: !useCustomPrice
        ? comp.component.prices?.[0]?.pricePointId?.toString() || null
        : null,
    };
  });
}
